import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ReliabilityEDSSystem from '../molecules/EPDSystemComponents/ReliabilityEDSSystem'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import EPDSysKeyFeatures from '../molecules/EPDSystemComponents/EPDSysKeyFeatures'
import EPDIdeaProject from '../molecules/EPDSystemComponents/EPDIdeaProject'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { getPageData, useData } from '../../app/helper/functions'
import { motion } from 'framer-motion'

const EPDSystemPage = () => {
    const { data } = useData();
    const epdSystemData = getPageData(data, 'epdSystemPage');

    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.6 } }
    };

    return (
        <div className="w-full overflow-hidden">
            <div className='bg-epdSystem-bg bg-center bg-cover bg-no-repeat overflow-hidden'>
                <div className='bg-blackTransparent'>
                    <motion.div 
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        variants={fadeInUp}
                        className='flex flex-col md:flex-row px-4 md:px-0 md:pr-[10%] gap-6 pt-20 sm:pt-32 md:pt-52 pb-8 md:pb-4'
                    >
                        <div className='z-10 w-full md:w-[60%] rounded-lg shadow-lg'>

                        </div>
                        {/* <img src={images.ENTERPRISEHOMEIMAGE} className='z-10 w-full md:w-[60%] rounded-lg shadow-lg' alt="Enterprise Home" /> */}
                        <div className='text-white flex flex-col gap-4 md:gap-2 relative text-center md:text-end justify-center items-end'>
                            <div className='font-bold text-3xl sm:text-4xl md:text-6xl mb-2 leading-tight'>{epdSystemData.title}</div>
                            <div className='font-normal text-lg sm:text-xl md:text-2xl max-w-2xl mx-auto md:mx-0'>{epdSystemData.description}</div>
                        </div>
                    </motion.div>
                </div>
            </div>
            <div className='bg-blackDark'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary py-6 sm:py-8 md:py-12 px-4 md:px-0'
                        subTitle='Why go for a custom EPD/EHR system?'
                        text="Proper patient data management is critical in healthcare. Custom EPD/EHR systems enhance
                        efficiency and care quality by fitting providers' specific workflows." />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                >
                    <ReliabilityEDSSystem epdSystemData={epdSystemData} />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary py-6 sm:py-8 md:py-12 px-4 md:px-0'
                        subTitle='How we approach EPD/EHR system creation'
                        text='Our EPD/EHR systems are built with a focus on patients and security, optimizing
                        workflows, strengthening data protection, & ensuring high-quality care.' />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                >
                    <EPDIdeaProject epdSystemData={epdSystemData} />
                </motion.div>

                <div className='pt-4 sm:pt-6 md:pt-10 bg-darkGreyPrimary px-4 md:px-0'>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeIn}
                    >
                        <AppsRunning bgImage='bg-confident-epdSys-bg'
                            title='Main features of our EPD/EHR systems'
                            subtitle='We create custom EPD/EHR systems that make managing patient information easier,
                        boost healthcare efficiency, and keep data safe. Key features are:' />
                    </motion.div>
                </div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                >
                    <EPDSysKeyFeatures epdSystemData={epdSystemData} />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <ProjectDisplay />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                >
                    <AppsFaq />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <AppsMaintenance bgImage='bg-maintenance-hospital-bg'
                        title='Initiate your EPD/EHR development project today.'
                        subtitle='Want to enhance patient care and simplify data management with a tailored EPD/EHR system?' />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                >
                    <DefaultFooter />
                </motion.div>
            </div>
        </div>
    )
}

export default EPDSystemPage
